import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from "@jti/ui";
import styles from "./CartPageHeader.module.scss";
export const CartPageHeader = ({ subtitle }) => {
    const { __ } = useTranslations();
    return (_jsxs("div", { className: styles.container, "data-testid": "cart-page-header", children: [_jsx("div", { className: styles.title, "data-testid": "cart-page-header-title", children: __("cart.title.cart") }), subtitle && (_jsx("span", { className: styles.subtitle, "data-testid": "cart-page-header-subtitle", children: subtitle }))] }));
};
//# sourceMappingURL=CartPageHeader.js.map